import React, { ReactNode } from "react";
import {
  createReducer,
  createStore,
  Provider as PRProvider,
} from "react-principal";
import { persistkeys } from "../constants/enum";

type languages = "fa" | "en";
interface InitialState {
  language: languages;
}
const initialState: InitialState = {
  language: "fa",
};

const SET_LANGUAGE = "SET_LANGUAGE";

const reducer = createReducer({
  SET_LANGUAGE: (state, { payload: { language } }) => ({
    ...state,
    language,
  }),
});

const setLanguage = (language: languages) => {
  return {
    type: SET_LANGUAGE,
    payload: { language },
  };
};
const store = createStore<InitialState>({
  reducer,
  initialState,
  persistKey: persistkeys.language,
  storage: window.localStorage,
  mapStateToPersist: ({ language }) => ({
    language, // persist just theme
  }),
});

const setLanguagePersistToState = () => store.setToState();

const ProviderLanguage = ({ children }: { children: ReactNode }) => {
  return <PRProvider {...{ store }}>{children}</PRProvider>;
};

export {
  ProviderLanguage,
  reducer as reducerLang,
  store as storeLang,
  setLanguage,
  setLanguagePersistToState,
};
